import dayjs from 'dayjs'
import jwtDecode from 'jwt-decode'
import { faro } from '@grafana/faro-web-sdk'

const localizedFormat = require('dayjs/plugin/localizedFormat')

export const areCookiesEnabled = () => {
  let cookieEnabled = !!navigator?.cookieEnabled

  if (typeof navigator?.cookieEnabled === 'undefined' && !cookieEnabled) {
    document.cookie = 'testcookie'
    cookieEnabled = document?.cookie.indexOf('testcookie') !== -1
  }
  return cookieEnabled
}

export const htmlToString = (html) => {
  const divContainer = document.createElement('div')
  divContainer.innerHTML = html
  return divContainer.textContent || divContainer.innerText || ''
}

export const returnErrors = (errorCode) => {
  if (!errorCode) return 'PAGE_NOT_FOUND'

  const code = errorCode.trim().toUpperCase().replace(/\s+/g, '_')

  if (
    code === 'NOT_FOUND' ||
    code === 'ENTITY_NOT_FOUND' ||
    code === 'BAD_REQUEST'
  ) {
    return 'QUIZ_NOT_FOUND'
  }
  if (code === 'QUIZ_NOT_STARTED') {
    return 'QUIZ_NOT_STARTED'
  }
  if (code === 'FORBIDDEN' || code === 'UNAUTHORIZED') {
    return 'ACCESS_DENIED'
  }
  if (code === 'INTERNAL_SERVER_ERROR' || code === 'DB_ERROR') {
    return 'INTERNAL_SERVER_ERROR'
  }
  if (code === 'SUBMISSION_EXISTS' || code === 'CONFLICT') {
    return 'QUIZ_ALREADY_SUBMITTED'
  }
  if (code === 'REDIRECT') {
    return 'REDIRECT'
  }

  return 'PAGE_NOT_FOUND'
}

export const convertInstructionsToPoints = (instructions) => {
  let pointsString = ''
  instructions?.split('\n')?.forEach((instruction, index) => {
    pointsString += `${index + 1}. ${instruction}\n\n`
  })
  return pointsString
}

export const getRequestHeader = () => {
  const token = JSON.parse(sessionStorage.getItem('tokenStorage'))
  if (token?.accessToken) {
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.accessToken}`,
    }
  }
  return { 'Content-Type': 'application/json' }
}

export const convertISOToLocalDateTime = (dateTime) => {
  dayjs.extend(localizedFormat)
  return dayjs(dateTime)?.format('lll')
}

export const isDateTimeInThePast = (startTime) => {
  return new Date() >= new Date(dayjs(startTime))
}

export const isDateTimeInTheFuture = (endTime) => {
  return new Date() > new Date(dayjs(endTime))
}

export const getSecondsRemainingFromDateTimeToNow = (dateTime) => {
  return (new Date(dayjs(dateTime)) - new Date()) / 1000
}

export const aceModesForLanguages = (language) => {
  if (language === 'c' || language === 'cpp') return 'c_cpp'
  return language
}

export const isLoggedIn = () => {
  if (areCookiesEnabled())
    return sessionStorage.getItem('isLoggedIn') === 'true'
  return false
}

export const getQuestionById = (quiz, currentQuestion) => {
  const returnQuestion = quiz?.questions?.filter((item) => {
    return item?.id === currentQuestion?.id
  })

  return returnQuestion?.[0]
}

export const delay = (ms) => new Promise((res) => setTimeout(res, ms))

export const secondsToMinutes = (secs) => {
  const minutes = Math.floor(secs / 60)
  let finalTimeFormat = ''
  if (minutes >= 1) {
    finalTimeFormat += `${minutes} minutes`
  } else {
    finalTimeFormat += `${secs} seconds`
  }

  return finalTimeFormat
}

export const secondsToTime = (secs) => {
  let hours = Math.floor(secs / (60 * 60))
  if (hours < 10) {
    hours = `0${hours}`
  }

  const divisorForMinutes = secs % (60 * 60)
  let minutes = Math.floor(divisorForMinutes / 60)
  if (minutes < 10) {
    minutes = `0${minutes}`
  }

  const divisorForSeconds = divisorForMinutes % 60
  let seconds = Math.ceil(divisorForSeconds)
  if (seconds < 10) {
    seconds = `0${seconds}`
  }

  const time = `${hours}:${minutes}:${seconds}`

  return time
}

export const pricingTableData = {
  data: [
    {
      id: 1,
      title: 'Public Quiz',
      subHeading: ' Create & share instantly',
      amount: 'Free',
      amountSubHeading: 'For unlimited users',
      features: [
        {
          description: 'Surveys & Guest mode quizzes',
        },
        {
          description: 'Multiple choice questions',
        },
        {
          description: 'True & False questions',
        },
        {
          description: 'Tab switch count',
        },
        {
          description: 'Candidate guest login',
        },
        {
          description: 'Instant results',
        },
      ],
    },
    {
      id: 2,
      title: 'Private Quiz ',
      subHeading: 'Tests on the go',
      amount: '1C',
      amountSubHeading: 'Per quiz attempt',
      features: [
        {
          description: 'Interviews & assessments',
        },
        {
          description: 'Multiple choice questions',
        },
        {
          description: 'True & False questions',
        },
        {
          description: 'Tab switch count',
        },
        {
          description: 'Candidate Google OAuth login',
        },
        {
          description: 'Instant results',
        },
        {
          description: 'Invite specific candidates',
        },
      ],
    },
    {
      id: 3,
      title: 'Private Quiz',
      subHeading: 'w/ Coding questions',
      amount: '3C',
      amountSubHeading: 'Per quiz attempt',
      features: [
        {
          description: 'Interviews & assessments',
        },
        {
          description: 'Multiple choice questions',
        },
        {
          description: 'True & False questions',
        },
        {
          description: 'Tab switch count',
        },
        {
          description: 'Candidate Google OAuth login',
        },
        {
          description: 'Instant results',
        },
        {
          description: 'Invite specific candidates',
        },
        {
          description: 'Coding questions',
        },
        {
          description: 'Six programming languages',
        },
      ],
    },
    {
      id: 4,
      title: 'Private Quiz',
      subHeading: 'w/ Proctoring',
      amount: '5C',
      amountSubHeading: 'Per quiz attempt',
      features: [
        {
          description: 'Interviews & assessments',
        },
        {
          description: 'Multiple choice questions',
        },
        {
          description: 'True & False questions',
        },
        {
          description: 'Tab switch count',
        },
        {
          description: 'Candidate Google OAuth login',
        },
        {
          description: 'Instant results',
        },
        {
          description: 'Invite specific candidates        ',
        },
        {
          description: 'Proctoring enabled',
        },
        {
          description: 'Real-time monitoring',
        },
      ],
    },
    {
      id: 5,
      title: 'Private Quiz',
      subHeading: 'w/ Proctoring & Coding questions',
      amount: '7C',
      amountSubHeading: 'Per quiz attempt',
      features: [
        {
          description: 'Interviews & assessments',
        },
        {
          description: 'Multiple choice questions',
        },
        {
          description: 'True & False questions',
        },
        {
          description: 'Tab switch count',
        },
        {
          description: 'Candidate Google OAuth login',
        },
        {
          description: 'Instant results',
        },
        {
          description: 'Invite specific candidates        ',
        },
        {
          description: 'Proctoring enabled',
        },
        {
          description: 'Real-time monitoring',
        },
        {
          description: 'Coding questions',
        },
        {
          description: 'Six programming languages',
        },
      ],
    },
  ],
}

/**
 * Folds the API's `counts.questions` array (`[{ type, count }]`) into a
 * per-type lookup with a `total`, the shape the onboarding pages render.
 * @function questionCountByType
 */
export const questionCountByType = (questionCounts) => {
  const counts = { mcq: 0, coding: 0, fillInTheBlanks: 0, essay: 0, total: 0 }

  questionCounts?.forEach((entry) => {
    if (!entry) return
    const { type } = entry
    const count = Number(entry.count) || 0
    // a type without its own bucket still counts towards the total
    if (type === 'mcq' || type === 'multi-choice') counts.mcq += count
    else if (type === 'coding') counts.coding += count
    else if (type === 'fill-in-blanks') counts.fillInTheBlanks += count
    else if (type === 'essay') counts.essay += count
    counts.total += count
  })

  return counts
}

export const decodeJwt = (jwtToken) => {
  try {
    const decodedInformation = jwtDecode(jwtToken)
    return decodedInformation
  } catch (error) {
    if (faro && faro.api && faro.api.pushError) {
      faro.api.pushError(error)
    }
    return null
  }
}
